<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> BlockList WhatsApp</h3>
      </div>
    </div>
    <BlockListListWhats ref="BlockListList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import BlockListListWhats from './components/list/BlockListListWhats.vue'

export default {
  name: 'BlockList',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    BlockListListWhats
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.BlockListAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/blocklist/BlockList/blockListWhatsApp.vue